import React from 'react';
import { Form } from 'antd/lib';
import { FormInstance } from 'antd/lib/form';
import { shouldUpdate } from '@xbcb/ui-utils';
import { password as passwordRegex } from '@xbcb/regex';
import {
  StyledPasswordHelperDiv,
  StyledPasswordHelperBlockDiv,
  StyledLegacyIcon,
} from './styles';

const getType = (valid?: boolean) => (valid ? 'check' : 'close');

type PasswordHelperProps = {
  form: FormInstance;
};

const PasswordHelper = ({ form }: PasswordHelperProps) => {
  const passwordNamePath = ['newPassword'];
  return (
    <Form.Item shouldUpdate={shouldUpdate([passwordNamePath])}>
      {() => {
        const password = form.getFieldValue(passwordNamePath);
        const length = password ? password.length >= 8 : false;
        const lowercase = password ? /[a-z]/g.test(password) : false;
        const uppercase = password ? /[A-Z]/g.test(password) : false;
        const number = password ? /[0-9]/g.test(password) : false;
        const symbol = password ? passwordRegex.test(password) : false;
        return (
          <StyledPasswordHelperDiv>
            <StyledPasswordHelperBlockDiv>
              <p>
                <StyledLegacyIcon type={getType(length)} $isValid={length} /> At
                least 8 characters long
              </p>
              <p>
                <StyledLegacyIcon
                  type={getType(lowercase)}
                  $isValid={lowercase}
                />{' '}
                At least 1 lowercase letter
              </p>
              <p>
                <StyledLegacyIcon
                  type={getType(uppercase)}
                  $isValid={uppercase}
                />{' '}
                At least 1 uppercase letter
              </p>
              <p>
                <StyledLegacyIcon type={getType(number)} $isValid={number} /> At
                least 1 number
              </p>
              <p>
                <StyledLegacyIcon type={getType(symbol)} $isValid={symbol} /> At
                least 1 symbol
              </p>
            </StyledPasswordHelperBlockDiv>
          </StyledPasswordHelperDiv>
        );
      }}
    </Form.Item>
  );
};

export default PasswordHelper;
